import React from 'react';
import { ADMIN_UI_BUILD } from '../../adminBuildInfo';

/** Pied de modale admin : version front + date/heure de compilation (fuseau Paris). */
export const AdminBuildStamp: React.FC = () => (
  <p
    className="pt-1 text-center text-[11px] font-medium tabular-nums text-slate-400"
    title={`Build ISO: ${ADMIN_UI_BUILD.buildAtIso}`}
  >
    Admin · v{ADMIN_UI_BUILD.version} · compilé {ADMIN_UI_BUILD.builtAtParisLabel} (Paris)
  </p>
);
